import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import LiveFeedPlay from '../LiveFeedPlay';
import initContainerData from 'bdata-react-component/lib/store/initContainerData';
import play from '../store/reducers/play';
import { getPlayState } from '../store/selectors/getPlayState';
import usePlayTimer from '@gameday/utils/hooks/usePlayTimer';

initContainerData.register({
    reducers: { play }
});

const LiveFeedPlayDataContainer = ({
    dataIndex,
    openAtBatOverlay,
    showPitchesOnly,
    showBasesText,
    ...otherProps
}) => {
    const {
        playData = {},
        teams = {},
        playVideoMap = {},
        currentPlayIndex,
        currentPlayEventsNumber,
        currentPlayResult,
        isLoading,
        deviceInteraction,
        playMetrics,
        language,
        playerMap,
        absConfig
    } = useSelector(getPlayState(dataIndex));
    const { timerNum } = usePlayTimer();

    const {
        resultPlayGuid
    } = playData;

    return (
        <LiveFeedPlay
            { ...otherProps }
            playData={ playData }
            playMetrics={ playMetrics }
            resultVideo={ playVideoMap[resultPlayGuid] }
            teams={ teams }
            keymoments={null}
            isLoading={ isLoading }
            language={ language }
            deviceInteraction={ deviceInteraction }
            currentPlayIndex={ currentPlayIndex }
            currentPlayEventsNumber={ currentPlayEventsNumber }
            currentPlayResult={ currentPlayResult }
            openAtBatOverlay={ openAtBatOverlay }
            showPitchesOnly={ showPitchesOnly }
            playerMap={playerMap}
            showBasesText={showBasesText}
            playTimer={timerNum}
            absConfig={absConfig}
        />
    );
};

LiveFeedPlayDataContainer.propTypes = {
    dataIndex: PropTypes.number,
    openAtBatOverlay: PropTypes.func,
    showPitchesOnly: PropTypes.bool,
    showBasesText: PropTypes.bool
};

export default LiveFeedPlayDataContainer;
